const axios = require('axios');

export function videos(token){
  return new Promise((res, rej)=>{
    axios.get(`https://www.googleapis.com/youtube/v3/playlistItems?part=id%2C%20snippet%2C%20contentDetails%2C%20status&maxResults=50&${token ? 'pageToken='+token : ''}&playlistId=UU6P1oKBG-UN4bINpInDO2gQ&key=AIzaSyD412VsBF30ekKRRD-f9UkeqIGiaDZRAbE`).then((response)=>{
    console.log('a');
    res({videos: response.data.items, nextPageToken: response.data.nextPageToken})
    })
  })
}

export function liveRequest(){
  return new Promise((res, rej)=>{
    axios.get(`https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UC6P1oKBG-UN4bINpInDO2gQ&eventType=live&type=video&key=AIzaSyD412VsBF30ekKRRD-f9UkeqIGiaDZRAbE`).then((response)=>{
      console.log('a');
      res({videos: response.data.items})
    })
  })
}
